// extracted by mini-css-extract-plugin
export default {"shoptetInstructionItem":"UploadProducts_shoptetInstructionItem__ZUCKJ","tooltipIcon":"UploadProducts_tooltipIcon__d8ftM","imgBox":"UploadProducts_imgBox__mN0CF"};